import { render, staticRenderFns } from "./bidOpenSituation.vue?vue&type=template&id=563e0231&scoped=true"
import script from "./bidOpenSituation.vue?vue&type=script&lang=js"
export * from "./bidOpenSituation.vue?vue&type=script&lang=js"
import style0 from "./bidOpenSituation.vue?vue&type=style&index=0&id=563e0231&prod&lang=scss&scoped=true"
import style1 from "./bidOpenSituation.vue?vue&type=style&index=1&id=563e0231&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563e0231",
  null
  
)

export default component.exports